import classnames from 'classnames/bind';
import { useTranslations } from 'next-intl';
import React from 'react';
import { Text } from '@portals/ui-kit';
import { Text as CustomText } from '@/_kit/text';
import { EColors, ECountries } from '@/_types';
import { ETextSize } from '@/_kit/text/_types';
import { BrowserLink } from '@/_kit/browser-link';
import { TTitleWrapper } from '../../_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'TitleWrapper';

type TProps = {
  onDownloadPdf: () => void;
  pdfLink: string;
  country: ECountries;
};

export const TitleWrapper = ({
  onDownloadPdf,
  title,
  downloadDetailedPdf,
  downloadPdf,
  pdfLink,
  country,
}: TProps & TTitleWrapper) => {
  const translations = useTranslations();

  const isShowBlock =
    country === ECountries.RU ||
    country === ECountries.ZH ||
    country === ECountries.BY ||
    country === ECountries.KZ;

  return (
    <div className={cn(BLOCK_NAME)}>
      <Text size="headline-m" text={translations(title)} tagType="h2" />
      {isShowBlock && (
        <div className={cn(`${BLOCK_NAME}__link-wrapper`)}>
          <Text
            color="grey900"
            size="body-l"
            text={translations(downloadDetailedPdf)}
          />
          <BrowserLink
            color={EColors.BLUE_500}
            onClick={onDownloadPdf}
            rel="noopener noreferrer"
            routeName={pdfLink}
            target="_blank"
          >
            <CustomText
              size={ETextSize.SMALL}
              text={translations(downloadPdf)}
              variant="body"
            />
          </BrowserLink>
        </div>
      )}
    </div>
  );
};
